// extracted by mini-css-extract-plugin
module.exports = {"hide":"slider-image_hide__ZTIzp","more-details":"slider-image_more-details__3Mnwa"};